import PropTypes from 'prop-types';


const If = (props) => props.test ? props.children : null;

If.propTypes = {
  children: PropTypes.node.isRequired,
  test: PropTypes.bool.isRequired,
}

export default If;
